import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });
api.interceptors.request.use(c => {
  const t = localStorage.getItem("blueplay_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export const money = n => `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;
export const err = e => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d) && d[0]?.msg) return d[0].msg.replace("Value error, ", "");
  return "Please check your details";
};
export const when = d => (d ? new Date(d).toLocaleString("en-IN") : "-");
export const fileUrl = p => (p ? `${BACKEND}${p}` : null);
